<footer>
  <div class="container pb-4">
    <div class="row">
      <!-- Help section -->
      <div class="col-md-3 footer-two-col">
        <h6 class="foot-sub-heading">{{ "footer.get-to-know" | translate }}</h6>
        <ul class="menu-list-item mb-0">
          <li class="menu-list-items">
            <a
              href="https://web.umang.gov.in/help/privacy-policy.htm"
              title="Privacy Policy"
              target="_blank"
              >{{ "footer.privacy-policy" | translate }}
            </a>
          </li>
          <li class="menu-list-items">
            <a
              href="https://web.umang.gov.in/help/cancellation-refund-policy.htm"
              title="Cancellation/Refund Policy"
              target="_blank"
              >{{ "footer.refund-policy" | translate }}
            </a>
          </li>
          <li class="menu-list-items">
            <a
              href="https://web.umang.gov.in/help/faqs/list?index=1"
              title="FAQ"
              target="_blank"
              >{{ "footer.faq" | translate }}
            </a>
          </li>
          <li class="menu-list-items">
            <a
              href="https://web.umang.gov.in/help/terms-and-conditions.htm"
              title="Terms of Service"
              target="_blank"
              >{{ "footer.terms-of-service" | translate }}
            </a>
          </li>
        </ul>
        <hr />
        <h6 class="foot-sub-heading">{{ "footer.grievance" | translate }}</h6>
        <ul class="menu-list-item mb-0">
          <li class="menu-list-items">
            <!-- href="https://web.umang.gov.in/web_new/department?url=cpgrams%2Fapi%2Fdeptt%2FcpgramsHtml&dept_id=62&dept_name=CPGRAMS" -->
            <a
              href="https://web.umang.gov.in/dept/62"
              title="cpgrams"
              target="_blank"
              >{{"footer.cpgram" | translate }}
            </a>
          </li>
          <li class="menu-list-items">
            <a
              href="https://web.umang.gov.in/dept/145"
              title="National Consumer Helpline"
              target="_blank"
              >{{ "footer.nationalConsumerHelpline" | translate }}
            </a>
          </li>
        </ul>
      </div>

      <!-- Quick link section -->
      <div class="col-md-3 footer-two-col">
        <h6 class="foot-sub-heading">{{ "footer.quick-links" | translate }}</h6>
        <ul class="menu-list-item mb-0">
          <li class="menu-list-items">
            <a routerLink="/aboutus" title="About Us">{{
              "pages.about-us" | translate
            }}</a>
          </li>
          <li class="menu-list-items">
            <a routerLink="/dashboard" title="Dashboard">{{
              "pages.dashboard" | translate
            }}</a>
          </li>
          <li class="menu-list-items">
            <a routerLink="/scheme/dashboard" title="Schemes">{{
              "pages.schemes" | translate
            }}</a>
          </li>
          <li class="menu-list-items">
            <a routerLink="/partners" title="Our Partners">{{
              "pages.our-partners" | translate
            }}</a>
          </li>
          <li class="menu-list-items">
            <a routerLink="/aboutus" fragment="contact-us" title="Contact Us">{{
              "pages.contact-us" | translate
            }}</a>
          </li>
          <!-- <li class="menu-list-items">
            <a routerLink="/partners" title="Our Partners">{{
              "pages.our-partners" | translate}} </a></li>-->
          <!-- <li class="menu-list-items">
            <a routerLink="/careers" title="Careers">{{
              "pages.careers" | translate
            }}</a>
          </li> -->

          <li class="menu-list-items">
            <a
              class="cursor-pointer"
              routerLink="/video_presentation"
              title="Video Presentation"
              >{{ "pages.video-guide" | translate }}</a
            >
          </li>
          <li class="menu-list-items">
            <a
              href="https://web.umang.gov.in/landing/flipbook/index.html"
              title="eBook"
              >{{ "footer.e-book" | translate }}
            </a>
          </li>
          <li class="menu-list-items">
            <a
              href="https://web.umang.gov.in/help/user-manual/list?index=1"
              title="User Manual"
              target="_blank"
              >{{ "footer.user-manual" | translate }}
            </a>
          </li>

          <li class="menu-list-items">
            <a
              class="cursor-pointer"
              routerLink="/accessibility"
              title="accessibility"
              (click)="logISLEvent()"
              >{{ "isl-chatbot.accessibility" | translate }}</a
            >
          </li>
        </ul>
      </div>

      <!-- Email newsletter & useful link section -->
      <div class="col-md-6 footer-newsletter-col">
        <!-- <h6 class="foot-sub-heading">
          {{ "footer.subscribe-newsletter" | translate }}
        </h6>
        <p>
          {{ "footer.newsletter-desc" | translate }}
        </p> -->

        <!-- Email newsletter form -->
        <!-- <form [formGroup]="emailSubsForm" (ngSubmit)="onSubscribe()">
          <div class="newsletter-wrapper">
            <div class="w-100 newsletter-wrapper__inner">
              <div class="flex-grow-1 me-0 me-sm-2">
                <input
                  #emailInput
                  class="w-100"
                  type="email"
                  placeholder="{{ 'footer.enter-your-email' | translate }}"
                  formControlName="email"
                /> -->

        <!-- Validation errors for email input -->
        <!-- <p
                  *ngIf="
                    emailControl?.value?.length &&
                    !emailSubsResp &&
                    emailControl.touched &&
                    (emailControl.hasError('required') ||
                      emailControl.hasError('pattern'))
                  "
                  class="validation-msg error"
                >
                  *{{ "error.correct-email" | translate }}
                </p> -->

        <!-- Messages of email subscription -->
        <!-- <p
                  *ngIf="emailSubsResp"
                  class="validation-msg"
                  [ngClass]="{
                    success: isEmailSubsSuccess,
                    error: !isEmailSubsSuccess
                  }"
                >
                  {{ emailSubsResp }}
                </p>
              </div>

              <button
                class="btn btn-primary"
                type="submit"
                [disabled]="isLoading"
                [title]="'buttons.subscribe' | translate"
              >
                <img
                  *ngIf="isLoading"
                  src="https://media.umangapp.in/cdn/landing/theme/icons/loader.gif"
                  alt="loader"
                  width="25px"
                  height="29px"
                  loading="lazy"
                  fetchpriority="high"
                  
                />
                <span>{{ "buttons.subscribe" | translate }}</span>
              </button>
            </div>
          </div>
        </form> -->

        <!-- Useful links section -->
        <h6 class="foot-sub-heading foot-sub-heading--useful-links">
          {{ "footer.useful-links" | translate }}
        </h6>
        <div class="useful-links-section">
          <ng-container *ngFor="let linkItems of usefulLinks">
            <a
              *ngIf="linkItems?.isVisible"
              target="_blank"
              [title]="linkItems?.title"
              role="button"
              (click)="openLink(linkItems)"
            >
              <img
                [src]="linkItems?.img"
                [alt]="linkItems?.alt"
                width="84"
                height="44"
                loading="lazy"
                class="footer-icon"
                fetchpriority="low"
              />
            </a>
          </ng-container>
        </div>
        <h6 
        class="foot-sub-heading foot-sub-heading--useful-links mt-5">
          {{'footer.visitors' | translate}}: <span app-animating-count
          [count]="totalVisitCount"
          [skips]="100000"
          [yOffset]="-200"
          class="button-shape"></span>
        </h6>
      </div>
    </div>
  </div>
  <div class="copyright">
    <div
      class="container flex-column flex-sm-row d-flex align-items-center justify-content-between"
    >
      <div
        class="powered-by-wrap mb-3 mb-sm-2 d-flex align-items-center flex-column-reverse flex-sm-row"
      >
        <span class="powered-by-txt text-center text-sm-left">{{
          "footer.dic-portal" | translate
        }}</span>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <span
        >{{ "footer.last-updated" | translate }}
        {{ pakageJSON.lastUpdatedOn }} | v-{{ pakageJSON.version }}</span
      >
    </div>
  </div>
</footer>
